import * as PIXI from 'pixi.js';
import { drawDottedLine, DottedLineStyle } from '../utils/drawing';
import { BRAND } from '../utils/constants';

const PREVIEW_LINE_STYLE: DottedLineStyle = {
  dotSpacing: 8,
  dotLength: 4,
  width: 3,
  color: BRAND.GOLD,
  alpha: 0.8
};

export class WirePreview extends PIXI.Container {
  private line: PIXI.Graphics;
  private startX: number;
  private startY: number;
  private pathNodes: Array<{ x: number; y: number }>;

  constructor(startX: number, startY: number) {
    super();
    
    this.startX = startX;
    this.startY = startY;
    this.pathNodes = [];
    
    this.line = new PIXI.Graphics();
    this.addChild(this.line);
    
    this.redraw(startX, startY);
  }

  addNode(x: number, y: number): void {
    this.pathNodes.push({ x, y });
    this.redraw(x, y);
  }

  removeLastNode(): void {
    if (this.pathNodes.length > 0) {
      this.pathNodes.pop();
      const lastPoint = this.pathNodes.length > 0 
        ? this.pathNodes[this.pathNodes.length - 1]
        : { x: this.startX, y: this.startY };
      this.redraw(lastPoint.x, lastPoint.y);
    }
  }

  updateCurrentPosition(x: number, y: number): void {
    this.redraw(x, y);
  }

  private redraw(currentX: number, currentY: number): void {
    this.line.clear();
    
    let lastX = this.startX;
    let lastY = this.startY;
    
    // Draw path through nodes
    this.pathNodes.forEach(node => {
      drawDottedLine(this.line, { x: lastX, y: lastY }, node, PREVIEW_LINE_STYLE);
      lastX = node.x;
      lastY = node.y;
    });

    // Draw line to current position
    drawDottedLine(this.line, { x: lastX, y: lastY }, { x: currentX, y: currentY }, PREVIEW_LINE_STYLE);
  }

  setInvalid(invalid: boolean): void {
    // Just redraw - the color will be handled in drawDottedLine
    const lastPoint = this.pathNodes.length > 0 
      ? this.pathNodes[this.pathNodes.length - 1]
      : { x: this.startX, y: this.startY };
    this.redraw(lastPoint.x, lastPoint.y);
  }
}